import React, { useState, useEffect } from "react";
import "./header.css";
import { HandbagSimple, Heart, List, User, CalendarBlank } from "phosphor-react";
import SideMenuBar from "../SideMenuBar/SideMenuBar";
import TextCarousel from "../TextCarousel/TextCarousel";
import { useSelector, useDispatch } from "react-redux";
import { logout, setSideMenuBarOpen } from '../../appState/slices/auth/authSlice';
import { Link, NavLink } from "react-router-dom";
import { signOut } from "@firebase/auth";
import { auth } from "../../firebase.config";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
import { ReactComponent as Logo } from '../../assets/logo/logo-name.svg';

<Link to="/" className="darkcolor brand-name t0">
  <Logo className="h-10 w-auto text-green-600" />
</Link>

const Header = () => {
  const sideMenuBarOpen = useSelector(state => state.auth.header.sideMenuBarOpen);
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch()

  const [scrolling, setScrolling] = useState(false);

  const [hoverShoppingBag, setHoverShoppingBag] = useState(false);
  const [hoverUser, setHoverUser] = useState(false);
  const [hoverCalender, setHoverCalenderr] = useState(false);
  const [hoverHeart, setHoverHeart] = useState(false);
  const handleMouseEnter = (hoverelement) => {
    if (hoverelement === "shoppingbag") {
      setHoverShoppingBag(true);
    }
    else if (hoverelement === "heart") {
      setHoverHeart(true);
    }
    else if (hoverelement === "user") {
      setHoverUser(true);
    }
     else if (hoverelement === "calenderblank") {
      setHoverCalenderr(true);
    }

  };
useEffect(() => {
  const rootElement = document.getElementById("root");

  const handleScroll = (event) => {
    const scrollPosition = event.currentTarget.scrollTop;
    setScrolling(scrollPosition > 10);
  };

  if (rootElement) {
    rootElement.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    // Set initial state
    handleScroll({ currentTarget: rootElement });
  }

  return () => {
    if (rootElement) {
      rootElement.removeEventListener("scroll", handleScroll);
    }
  };
}, []);
  const handleMouseLeave = (hoverelement) => {
    if (hoverelement == "shoppingbag") {
      setHoverShoppingBag(false);
    }
    else if (hoverelement == "heart") {
      setHoverHeart(false);
    }
    else if (hoverelement === "user") {
      setHoverUser(false);
    }
     else if (hoverelement === "calenderblank") {
      setHoverCalenderr(false);
    };
    
  }
  const updateSideMenuBarOpen = (newvalue) => {
    dispatch(setSideMenuBarOpen(newvalue));
  }
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const items = ["BEST PRICE GAURANTEED", "BY APPOINTMENT ONLY"];
  return (
    <div>
      {sideMenuBarOpen ?
        <SideMenuBar />
        :
        null}
      <div>
        <div>
          <div className={`special-codes topnavbarpart`}>
            <TextCarousel items={items} interval={3000} />
          </div>
        </div>
<nav
  className={`darkcolor nav-container headercontainer ${
    scrolling ? "headerbglight" : ""
  }`}
>          <div className="left-side">
            <button onClick={() => updateSideMenuBarOpen(true)}>
              <List size={20} className={`darkcolor`} />
            </button>

            {/* Apply dimensions and color to the parent Link */}
            <Link
              to="/"
              className="darkcolor brand-name t0"
            >
              {/* Remove most classes from Logo, let it inherit */}
              <Logo className="darkcolor logo-div"
                
              />   
               </Link>
          </div>
          <div className="right-side">
            {
              isLoggedIn ?
                <NavLink to="/appointment" className={`darkcolor`}>
                  <CalendarBlank onMouseEnter={() => handleMouseEnter("calenderblank")} onMouseLeave={() => handleMouseLeave("calenderblank")} size={20} weight={hoverCalender ? "fill" : null} />
                </NavLink>
                :
                null
            }
            {
              user ?
              <Link to="/cart" className={`darkcolor`}>
              <HandbagSimple onMouseEnter={() => handleMouseEnter("shoppingbag")} onMouseLeave={() => handleMouseLeave("shoppingbag")} size={20} weight={hoverShoppingBag ? "fill" : null} />
            </Link>
              :
              null
            }
              {
              user ?
            <Link to="/wishlist" className={`darkcolor`}>
              <Heart onMouseEnter={() => handleMouseEnter("heart")} onMouseLeave={() => handleMouseLeave("heart")} size={20} weight={hoverHeart ? "fill" : null} />
            </Link>
            :
            null
            }
            {
              isLoggedIn ?
                <NavLink to="/profile" className={`darkcolor`}>
                  <User onMouseEnter={() => handleMouseEnter("user")} onMouseLeave={() => handleMouseLeave("user")} size={20} weight={hoverUser ? "fill" : null} />
                </NavLink>
                :
                <Link to="/login"><button className={`darkcolor login-btn `}>Login</button></Link>
            }
          </div>
        </nav>
      </div>
    </div>

  );
};

export default Header;
